import React from 'react';
import Select from '../Select/Select';

const options = [
  { value: 1, label: 'ÐÐ¾Ð¼Ð°ÑÐ½Ð¸Ð¹' },
  { value: 2, label: 'ÐÐ¾ÑÐ¿Ð¾ÑÐ°ÑÐ¸Ð²Ð½ÑÐ¹' },
];

const SelectAddressType = ({ ...props }) => {
  return <Select options={options} label={'Ð¢Ð¸Ð¿ Ð°Ð´ÑÐµÑÐ°'} placeholder={'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°'} {...props} />;
};

export default SelectAddressType;
